// src/components/ScrollToTop/ScrollToTopBtn.jsx

'use client'

import styles from './ScrollToTopBtn.module.scss';


const upIcon = (
  <svg style={{verticalAlign: 'middle'}} data-testid="geist-icon" fill="none" height="24" 
    shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" 
    strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24" aria-hidden="true"
    role="img" aria-labelledby="upIconTitle">
    <title id="upIconTitle">Arrow pointing up</title>
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M16 12l-4-4-4 4"></path>
    <path d="M12 16V8"></path>
  </svg>
)


export default function ScrollToTopBtn() {

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  return (
    <button
      type={'button'}
      onClick={handleClick}
      className={styles.button}
      aria-label="Scroll to top of page"
    >Scroll to Top {upIcon}</button>
  )
}
